<style lang="less">
.itembank{
	width: 100%;
	.vue-item{
		height: 72px;
	}
	&.active{
		.vue-item-submark__subject{
			color: #000;
		}
	}
}
</style>

<template>
	<!-- Main itembank -->
	<div :class="bank.index == -1 ? 'itembank' : 'itembank active' ">
		<item
			mark-subject="银行卡"
			mark-subject-attach=""
			:submark-subject="bank.index == -1 ? '请选择' : bankInfo.bank_name + ' ' + bankInfo.bank_no_last4"
			:submark-subject-attach="limit"
			:ico-type="iconType"
			@click.native="choose_bank"
		></item>

		<poplist :show="bank.isShow" :list="bank.data" v-on:impress="bank_pop" :selectindex="bank.index"></poplist>

	</div>

</template>

<script>
	import item from '@flyme/jr/flyme7/component/item/vue-item.vue';
	import android from '@flyme/jr/js/android.js';
	import poplist from '@flyme/jr/flyme7/component/pop-list/pop-list.vue';

	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				userinfo: {},
				bank: {
					index: -1,
					isShow: false,
					data: [],
				},
				bankInfo: {},
				acct: {},
				iconType: ''
			};
		},
		computed: {
			limit: function () {
				if (this.bankInfo.st) {
					return '单笔限额 '+ parseFloat(this.bankInfo.st / 10000) +' 万元，单日限额 '+ parseFloat(this.bankInfo.dt / 10000) +' 万元';
				} else {
					return '';
				}

			}
		},
		components: {
			item,
			poplist
		},
		created: function () {
			this.getAcct();
			this.get_banks_data();
		},
		methods: {
			getUserInfo: function () {
				let _this = this;
				android('getUserInfo', {}, (d) => {
					_this.userinfo = d;
					this.get_banks_data();
				});
			},
			get_banks_data: function() {
				let _this = this;
				axios.post(apis.acct_bank_get, {
					// user_id: this.userinfo.userId,
					// partner_id: config.partner_id,
					// partner_cp_type: config.partner_cp_type
				}).then(function(d) {
					console.log('acct_bank_get', d);
					_this.bankInfo = d.value;
					// var bank_data = [];
					// for( var i in d.value.rows){
					// 	bank_data.push({
					// 		"id": d.value.rows[i].bankAccNoIndex,
					// 		"text": d.value.rows[i].bankName + ' ' + d.value.rows[i].bankNoLast4,
					// 		"raw": d.value.rows[i]
					// 	});
					// }
					// _this.bank.data = bank_data;
					_this.sendInitSelect();
				});
			},
			getAcct: function () {
				let _this = this;
				axios.post(apis.acct_query, {
					show_type: 0
				}).then(function(d) {
					console.log('acct_query', d.value, d.value.acctplus_account_info);
					_this.acct = d.value;
					if (_this.acct.acctplus_account_info) {
						if (_this.acct.acctplus_account_info.total_asset == 0 && _this.acct.acct_account_info.avaliable_bal == 0) {
							_this.iconType = "next";
						}
					}else{
						if (_this.acct.acct_account_info.avaliable_bal == 0) {
							_this.iconType = "next";
						}
					}
				});
			},
			bank_pop: function(index) {
				this.bank.index = index;
				this.bank.isShow = false;
			},
			choose_bank: function() {
				if (this.iconType != 'next') {
					return;
				}

				let _this = this;
				android('startPageWithCallback', {
					url:'https://jr-res.meizu.com/resources/jr/flyme7/html/mine/card_list.html?partner_id='+ config.partner_id +'&partner_cp_type='+ config.partner_cp_type + '&business=ecash',
					start_type:1,
					data:'',
					display:{
						title:'银行卡'
					}
				}, function () {
					_this.get_banks_data();
				});

			},
			sendInitSelect: function () {
				this.bank.index = 0;
				this.$emit('bankSelect', this.bankInfo);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/itembank.vue